var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMotorOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#040006;}.cls-3{fill:#28b528;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-motor-on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_37",
    "data-name": 37
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.08,57.16v4.59H126.84V84.93h36.54a.41.41,0,0,1,.41.42V115.2H180.5V100.07h5.43v40.4H180.5V125.64H164.21v12.73a.83.83,0,0,1-.24.58l-22.32,22a2.89,2.89,0,0,1-2,.84H98.94a2.92,2.92,0,0,1-2.16-1L84,146.64l-2-2.2H72A4.08,4.08,0,0,1,68,140.36V125.64H48.75v18.59H43.32v-42h5.43v18.58H68V106.75A4.07,4.07,0,0,1,72,102.68h9.59l2-2.26L96.41,85.91a2.93,2.93,0,0,1,2.18-1H121.2V61.75H105.54V57.16h36.54m2.82-6.68H102.72a3.86,3.86,0,0,0-3.86,3.86V64.57a3.86,3.86,0,0,0,3.86,3.86h11.8v9.82H98.59a9.6,9.6,0,0,0-7.19,3.24L78.61,96H72a10.75,10.75,0,0,0-10.75,10.76v7.41H55.43v-15a3.55,3.55,0,0,0-3.55-3.55H40.19a3.55,3.55,0,0,0-3.55,3.55v48.23a3.55,3.55,0,0,0,3.55,3.55H51.88a3.55,3.55,0,0,0,3.55-3.55v-15h5.85v8A10.75,10.75,0,0,0,72,151.12h7l12.81,14.17a9.58,9.58,0,0,0,7.11,3.16h40.67a9.57,9.57,0,0,0,6.73-2.76l22.32-22a7.51,7.51,0,0,0,2.23-5.35v-6h2.93v11a3.81,3.81,0,0,0,3.81,3.81H188.8a3.82,3.82,0,0,0,3.81-3.81V97.2a3.82,3.82,0,0,0-3.81-3.82H177.63a3.81,3.81,0,0,0-3.81,3.82v11.32h-3.35V85.35a7.09,7.09,0,0,0-7.09-7.1H133.52V68.43H144.9a3.86,3.86,0,0,0,3.86-3.86V54.34a3.86,3.86,0,0,0-3.86-3.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "134.77 121.26 109.51 155.5 118.47 127.94 102.83 127.94 118.47 97.04 134.77 97.04 119.32 121.26 134.77 121.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMotorOn);
export default __webpack_public_path__ + "static/media/ic-motor-on.203e8ba0458e12bc6b001fca266240d5.svg";
export { ForwardRef as ReactComponent };